import { useEffect, useRef, useState, useMemo } from "react";

import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import { ImprimirDefeitoColaborador } from "../components/Impressoes/ImprimirDefeitoColaborador";
import { FilterMatchMode } from 'primereact/api';

import Menu from "../components/Menu";

import api from "../services/api";

const booleans = [
    { label: 'Não', value: false },
    { label: 'Sim', value: true }
];

export default function HistoricoParada() {
    const navigate = useNavigate();

    const [colaboradores, setColaboradores] = useState([]);
    const [config, setConfig] = useState({});
    const [defeitos, setDefeitos] = useState([]);
    const [display, setDisplay] = useState(false);
    const [data, setData] = useState([]);
    const [editing, setEditing] = useState(false);
    const [options, setOptions] = useState([]);
    const [printing, setPrinting] = useState(false);
    const [sala, setSala] = useState([]);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [filtered, setFiltered] = useState([]);
    
    const [minMetragem, setMinMetragem] = useState(0);

    const [isVisible, setIsVisible] = useState(false);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        revisor: { value: null, matchMode: FilterMatchMode.CONTAINS },
        colaborador: { value: null, matchMode: FilterMatchMode.CONTAINS },
        defeito: { value: null, matchMode: FilterMatchMode.CONTAINS },
        turma: { value: null, matchMode: FilterMatchMode.CONTAINS },
        grupo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        tear: { value: null, matchMode: FilterMatchMode.CONTAINS },
        artigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nomerolo: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const showError = (error) => {
        toast.current.show({
            summary: 'Ocorreu um Erro',
            severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    }

    const handlePrint = useReactToPrint({
        content: () => component.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });

    const handlePrintColaboradores = () => {
        setIsVisible(true);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            revisor: { value: null, matchMode: FilterMatchMode.CONTAINS },
            colaborador: { value: null, matchMode: FilterMatchMode.CONTAINS },
            defeito: { value: null, matchMode: FilterMatchMode.CONTAINS },
            turma: { value: null, matchMode: FilterMatchMode.CONTAINS },
            grupo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            tear: { value: null, matchMode: FilterMatchMode.CONTAINS },
            artigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            nomerolo: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };

    const toast = useRef(null);
    const select = useRef(null);
    const component = useRef(null);

    const formik = useFormik({
        initialValues: {
            colaborador_id: '',
            defeito_id: '',
            artigo: '',
            nome_rolo: '',
            rolo: '',
            rolada: '',
            lote: '',
            metragem: '',
            data: new Date(),
            data_corte: '',
            tear: '',
            comecou_engrupagem: false
        },
        validate: function (data) {
            let errors = {};

            if (!data.colaborador_id) errors.colaborador_id = 'Colaborador é um campo obrigatório';
            if (!data.defeito_id) errors.defeito_id = 'Defeito é um campo obrigatório';
            if (!data.artigo) errors.artigo = 'Artigo é um campo obrigatório';
            if (!data.rolo) errors.rolo = 'Rolo é um campo obrigatório';
            if (!data.rolada) errors.rolada = 'Rolada é um campo obrigatório';
            if (!data.lote) errors.lote = 'Lote é um campo obrigatório';
            if (!data.data) errors.data = 'Data é um campo obrigatório';
            if (!data.data_corte) errors.data_corte = 'Data do Corte é um campo obrigatório';
            if (!data.metragem) errors.metragem = 'Metragem é um campo obrigatório';
            if (/\D/g.test(data.metragem)) errors.metragem = 'Metragem precisa ser númerico';
            if (!data.tear) errors.tear = 'Tear é um campo obrigatório';
            if(!data.nome_rolo) errors.nome_rolo = 'Nome do Rolo é um campo obrigatório';
            if (/\D/g.test(data.tear)) errors.tear = 'Tear precisa ser númerico';
            if (data.tear.length > 2) errors.tear = 'Tear contém apenas dois caracteres';
            if (data.tear > config.teares) errors.tear = 'Não existe nenhum tear com esse número';

            return errors;
        },
        onSubmit: function (data) {
            if (editing) {
                handleUpdate(data);
            } else {
                handleSubmit(data);
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error p-d-block p-mt-1">{formik.errors[name]}</small>;
    };

    const handleClick = () => {
        if (initialDate === null || finalDate === null) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Preencha os campos de Data para prosseguir'
            });
            return;
        }
        let formated1 = initialDate.getFullYear() + '-' + (initialDate.getMonth() + 1) + '-' + initialDate.getDate();
        let formated2 = finalDate.getFullYear() + '-' + (finalDate.getMonth() + 1) + '-' + finalDate.getDate();

        api.get(`defeitos/historico/${formated1}/${formated2}`).then((response) => {
            setData(response.data);
            if (response.data.historico.length === 0) {
                toast.current.show({
                    summary: 'Não encontrado',
                    severity: 'info',
                    detail: 'Nenhum registro encontrado para a data informada.'
                });
            }
        }).catch((error) => {
            showError(error);
        });
    }

    const handleSubmit = (formData) => {
        api.post('defeitos/store', formData).then((response) => {
            hideDialog();
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            showError(error);
        });
    }

    const handleUpdate = (formData) => {
        api.post('defeitos/update', formData).then((response) => {
            hideDialog();
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            showError(error);
        });
    }

    const hideDialog = () => {
        if (editing) setEditing(false);
        setDisplay(false);
    }

    useEffect(() => {
        let tear = formik.values.tear;
        if (parseInt(tear)) {
            let posicaoSala = sala.find((element) => {
                return parseInt(element.tear) === parseInt(tear);
            });

            if(posicaoSala) {
                let filtered = colaboradores.filter(element => {
                    return element.nome.substring(element.nome.length - 1, element.nome.length) === posicaoSala.grupo + '';
                });
                setOptions(filtered);
            }
        }
    }, [formik.values.tear, config, colaboradores, sala]);

    useEffect(() => {
        api.get('defeitos').then((response) => {
            setColaboradores(response.data.colaboradores);
            setConfig(response.data.config);
            setDefeitos(response.data.defeitos);
            setSala(response.data.sala);
        }).catch((error) => {
            showError(error);
        });
    }, []);

    const historicoExibido = useMemo(() => {
        if (!data.historico) return [];
        const limite = minMetragem === null ? 0 : minMetragem;

        return data.historico.filter(item => {
            const valMetragem = parseFloat(String(item.metragem).replace(',', '.')) || 0;
            return valMetragem >= limite;
        });
    }, [data.historico, minMetragem]);

    useEffect(() => {
        setFiltered(historicoExibido);
    }, [historicoExibido]);

    const cardHeader = (
        <div className="p-d-flex p-flex-row p-jc-between p-ai-center p-p-3 p-mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <h1 className="p-m-0" style={{ color: '#495057' }}>
                Histórico de Defeitos {data.periodo ? `- ${data.periodo}` : ""}
            </h1>
            <Button 
                label="Novo Registro" 
                icon="pi pi-plus" 
                className="p-button-primary" 
                onClick={() => {
                    setDisplay(true);
                    formik.resetForm();
                }} 
            />
        </div>
    );

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog
                draggable={false}
                className="p-m-3"
                style={{ width: '60vw' }}
                header={editing ? "Editar Registro" : "Cadastrar Novo Registro"}
                onHide={hideDialog}
                visible={display}
            >
                <form onSubmit={formik.handleSubmit} className="p-fluid p-formgrid p-grid p-mt-2">
                    <div className="p-field p-col-4">
                        <label htmlFor="tear">Tear</label>
                        <InputText id="tear" onChange={formik.handleChange} placeholder="Nº do Tear" value={formik.values.tear} />
                        {getFormErrorMessage('tear')}
                    </div>
                    <div className="p-field p-col-4">
                        <label htmlFor="colaborador_id">Colaborador</label>
                        <Dropdown filter id="colaborador_id" emptyFilterMessage="Nenhum resultado." options={options} optionLabel="nome" optionValue="id" onChange={formik.handleChange} ref={select} value={formik.values.colaborador_id} placeholder="Selecione..." />
                        {getFormErrorMessage('colaborador_id')}
                    </div>
                    <div className="p-field p-col-4">
                        <label htmlFor="defeito_id">Defeito</label>
                        <Dropdown filter id="defeito_id" options={defeitos} optionLabel="nome" optionValue="id" onChange={formik.handleChange} value={formik.values.defeito_id} placeholder="Selecione..." />
                        {getFormErrorMessage('defeito_id')}
                    </div>
                    
                    <div className="p-field p-col-3">
                        <label htmlFor="artigo">Artigo</label>
                        <InputText id="artigo" onChange={formik.handleChange} value={formik.values.artigo} />
                        {getFormErrorMessage('artigo')}
                    </div>
                    <div className="p-field p-col-2">
                        <label htmlFor="nome_rolo">Nome do Rolo</label>
                        <InputMask id="nome_rolo" mask="99-9999" onChange={formik.handleChange} value={formik.values.nome_rolo} />
                        {getFormErrorMessage('nome_rolo')}
                    </div>
                    <div className="p-field p-col-2">
                        <label htmlFor="rolo">Nº Rolo</label>
                        <InputText id="rolo" onChange={formik.handleChange} value={formik.values.rolo} />
                        {getFormErrorMessage('rolo')}
                    </div>
                    <div className="p-field p-col-2">
                        <label htmlFor="rolada">Rolada</label>
                        <InputMask id="rolada" mask="99-999" onChange={formik.handleChange} value={formik.values.rolada} />
                        {getFormErrorMessage('rolada')}
                    </div>
                    <div className="p-field p-col-3">
                        <label htmlFor="lote">Lote</label>
                        <InputText id="lote" onChange={formik.handleChange} value={formik.values.lote} />
                        {getFormErrorMessage('lote')}
                    </div>

                    <div className="p-field p-col-3">
                        <label htmlFor="metragem">Metragem</label>
                        <InputText id="metragem" onChange={formik.handleChange} value={formik.values.metragem} />
                        {getFormErrorMessage('metragem')}
                    </div>
                    <div className="p-field p-col-3">
                        <label htmlFor="data">Data</label>
                        <Calendar dateFormat="dd/mm/yy" id="data" onChange={formik.handleChange} value={formik.values.data} showIcon />
                        {getFormErrorMessage('data')}
                    </div>
                    <div className="p-field p-col-3">
                        <label htmlFor="data_corte">Data do Corte</label>
                        <Calendar dateFormat="dd/mm/yy" id="data_corte" onChange={formik.handleChange} value={formik.values.data_corte} showIcon />
                        {getFormErrorMessage('data_corte')}
                    </div>
                    <div className="p-field p-col-3">
                        <label htmlFor="comecou_engrupagem">Começou na Engrupagem?</label>
                        <Dropdown id="comecou_engrupagem" onChange={formik.handleChange} options={booleans} value={formik.values.comecou_engrupagem} />
                    </div>

                    <div className="p-d-flex p-jc-end p-col-12 p-mt-2">
                        <Button type="button" className="p-button-text p-button-secondary p-mr-2" label="Cancelar" onClick={hideDialog} />
                        <Button type="submit" className="p-button-success" icon="pi pi-check" label={editing ? "Salvar Alterações" : "Cadastrar"} />
                    </div>
                </form>
            </Dialog>

            <ImprimirDefeitoColaborador data={filtered} visible={isVisible} setIsVisible={setIsVisible} />

            <div className="p-m-3">
                <Card header={cardHeader}>
                    <div className="p-d-flex p-jc-between p-ai-end p-flex-wrap p-mb-3" style={{ gap: '1rem' }}>
                        <div className="p-d-flex p-ai-end p-flex-wrap" style={{ gap: '0.5rem' }}>
                            <div className="p-field p-m-0">
                                <label className="p-d-block p-text-secondary" style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>Data Inicial</label>
                                <Calendar dateFormat="dd/mm/yy" mask="99/99/9999" onChange={e => setInitialDate(e.value)} value={initialDate} />
                            </div>
                            <div className="p-field p-m-0">
                                <label className="p-d-block p-text-secondary" style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>Data Final</label>
                                <Calendar dateFormat="dd/mm/yy" mask="99/99/9999" onChange={e => setFinalDate(e.value)} value={finalDate} />
                            </div>
                            <Button className="p-button-success" icon="pi pi-search" onClick={handleClick} tooltip="Filtrar Período" />
                        </div>

                        <div className="p-field p-m-0">
                            <label className="p-d-block p-text-secondary p-text-right" style={{ fontSize: '0.875rem', marginBottom: '0.25rem', fontWeight: '600' }}>Ocultar abaixo de (m):</label>
                            <InputNumber 
                                value={minMetragem} 
                                onValueChange={(e) => setMinMetragem(e.value)} 
                                mode="decimal" 
                                minFractionDigits={2} 
                                maxFractionDigits={2}
                                showButtons
                                buttonLayout="horizontal"
                                incrementButtonIcon="pi pi-plus"
                                decrementButtonIcon="pi pi-minus"
                                incrementButtonClassName="p-button-secondary p-button-success"
                                decrementButtonClassName="p-button-secondary p-button-danger"
                                inputStyle={{ width: '6rem', textAlign: 'center' }}
                            />
                        </div>
                    </div>

                    <div className="p-d-flex p-jc-between p-ai-center p-flex-wrap p-p-2 p-mb-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #e9ecef', gap: '1rem' }}>
                        <div className="p-d-flex p-flex-wrap" style={{ gap: '0.5rem' }}>
                            <Button icon="pi pi-print" onClick={handlePrint} className="p-button p-button-secondary" />
                            <Button icon="pi pi-users" label="Colaboradores" onClick={handlePrintColaboradores} className="p-button p-button-danger" />
                            <Button 
                                icon="pi pi-file" 
                                label="Relatório por Defeito" 
                                onClick={() => {
                                    navigate('/defeitos/historico/relatorio', { state: { dadosRelatorio: filtered, initialDate, finalDate } });
                                }} 
                                className="p-button p-button-warning" 
                            />
                            <Button 
                                icon="pi pi-file" 
                                label="Relatório por Rolo" 
                                onClick={() => {
                                    navigate('/defeitos/historico/relatoriorolo', { state: { dadosRelatorio: filtered, initialDate, finalDate } });
                                }} 
                                className="p-button p-button" 
                            />
                        </div>
                        
                        <div className="p-d-flex p-ai-center" style={{ gap: '0.5rem' }}>
                            <span className="p-input-icon-left" style={{ width: '100%', maxWidth: '300px' }}>
                                <i className="pi pi-search" />
                                <InputText 
                                    value={globalFilterValue} 
                                    onChange={onGlobalFilterChange} 
                                    placeholder="Pesquisa Global..." 
                                    style={{ width: '100%' }}
                                />
                            </span>
                            <Button 
                                type="button" 
                                icon="pi pi-filter-slash"
                                tooltip="Limpar"
                                className="p-button-text p-button-secondary" 
                                onClick={clearFilter} 
                            />
                        </div>
                    </div>

                    <DataTable
                        dataKey="id"
                        filterDisplay="row"
                        filters={filters}
                        onFilter={(e) => setFilters(e.filters)}
                        globalFilterFields={['revisor', 'colaborador', 'defeito', 'turma', 'grupo', 'tear', 'artigo', 'nomerolo']}
                        emptyMessage="Nenhum registro encontrado com os filtros atuais." 
                        onValueChange={(filteredData) => {
                            setFiltered(filteredData);
                        }}
                        responsiveLayout={printing ? "" : "scroll"}
                        ref={component}
                        value={historicoExibido}
                        stripedRows
                        size="small"
                        style={{ fontSize: printing ? 14 : 15 }}
                    >
                        {/* <Column sortable={!printing} header="ID" field="id" /> */}
                        <Column sortable={!printing} header="Revisor" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="revisor" style={{ width: "8%" }} />
                        <Column sortable={!printing} header="Colaborador" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="colaborador" style={{ width: "10%" }} />
                        <Column sortable={!printing} header="Defeito" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="defeito" style={{ width: "10%" }} />

                        <Column sortable={!printing} header="Data" sortField="data" field="dataf" style={{ width: "7%" }} />
                        <Column sortable={!printing} header="Data do Corte" sortField="datacorte" field="datacortef" style={{ width: "7%" }} />

                        <Column sortable={!printing} header="T" filter={!printing} showFilterMenu={false} filterPlaceholder="..." sortField="turma" field="turma" style={{ width: "5%" }} />
                        <Column sortable={!printing} header="G" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="grupo" style={{ width: "5%" }} />

                        <Column sortable={!printing} header="Tear" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="tear" style={{ width: "5%" }} />
                        <Column sortable={!printing} header="(m)" field="metragem" style={{ width: "5%" }} />
                        <Column sortable={!printing} header="Qtd. Ocorr." field="quantidade" style={{ width: "5%" }} />
                        <Column sortable={!printing} header="M. Rolo" field="metro_rolo" style={{ width: "5%" }} />

                        <Column header="Art." filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="artigo" style={{ width: "5%" }} />

                        <Column header="Nome Rolo" filter={!printing} showFilterMenu={false} filterPlaceholder="..." field="nomerolo" style={{ width: "10%" }} />
                        <Column header="Nº Rolo" field="rolo" style={{ width: "4%" }} />
                        <Column header="Rolada" field="rolada" style={{ width: "4%" }} />
                        <Column header="Lote" field="lote" style={{ width: "5%" }} />
                    {/* {printing === false ? (
                        <Column header="Ações" body={(rowData, index) => (
                            <div style={{ minWidth: '100px' }}>
                                <Button className="p-button-primary p-mr-1" icon="pi pi-pencil" onClick={() => {
                                    setEditing(true);
                                    setDisplay(true);

                                    let copy = { ...rowData };

                                    copy.rolo = copy.rolo.replace('p', '');
                                    copy.data = new Date(copy.data.replace(/-/g, '/'));
                                    copy.data_corte = new Date(copy.data_corte.replace(/-/g, '/'));

                                    formik.setValues(copy);
                                }} />
                                <Button className="p-button-danger p-ml-1" icon="pi pi-trash" onClick={() => handleDelete(rowData, index.rowIndex)} />
                            </div>
                        )} />
                    ): null} */}
                    </DataTable>
                </Card>
            </div>
        </div>
    )
}